import api from "./index";

export interface LectureListParams {
  companyId: string;
  ids?: Array<string>;
  ownerId?: string;
  title?: string;
  hoursMin?: number;
  hoursMax?: number;
  enabled?: boolean;
  locale?: string;
  createdAtMin?: Date;
  createdAtMax?: Date;
  updatedAtMin?: Date;
  updatedAtMax?: Date;
  offset?: number;
  limit?: number;
  sort?: "id" | "title" | "createdAt" | "updatedAt";
  order?: "ASC" | "DESC";
  options?: any;
}

export default (params: LectureListParams, options?: any) => {
  return api.LectureApi.list(
    params.companyId,
    params.ids,
    params.ownerId,
    params.title,
    params.hoursMin,
    params.hoursMax,
    params.enabled,
    params.locale,
    params.createdAtMin,
    params.createdAtMax,
    params.updatedAtMin,
    params.updatedAtMax,
    params.offset,
    params.limit,
    params.sort,
    params.order,
    params.options,
  );
};
